import { ToastMessage, type } from "@/lib/toastr";
import { login } from "@/services/Auth.service";
import { Storage } from "@/services/storage-services";
import { ERROR, LOGIN_SUCCESS, LOGOUT, REQUEST_LOGIN } from "./types";

export async function loginUser(dispatch, loginPayload) {
  try {
    dispatch({ type: REQUEST_LOGIN });
    const response = await login(loginPayload);

    if (response.data.data) {
      dispatch({ type: LOGIN_SUCCESS, payload: response?.data?.data });
      Storage.setItem(
        "TreasuraAdminUserToken",
        response?.data?.data?.accessToken
      );
      Storage.setItem("user", response?.data?.data);
      Storage.setItem("teams", response?.data?.data?.teams);
      Storage.setItem("twoFa", response?.data?.data?.twoFactorAuthentication);

      return response;
    }
    return;
  } catch (error) {
    console.log(error);
    await dispatch({
      type: ERROR,
      payload: error.response.data.message,
    });
    console.log(error);
    await ToastMessage(type.ERROR, error.response.data.message);
  }
}

export async function logout(dispatch) {
  dispatch({ type: LOGOUT });
  localStorage.removeItem("TreasuraAdminUserToken");
}
